export function assertCast<T>(_v: any): asserts _v is T {}
